/**
 * Accordion Library
 */
import Accordion from 'accordion-js';

document.addEventListener('DOMContentLoaded', function () {
	const accordions = Array.from(document.querySelectorAll('.accordion-container'));
	new Accordion(accordions, {
		duration: 400,
		showMultiple: true
	});
}, false);